module.exports = __webpack_public_path__ + "img/product_19.4cef3b4.svg";